import workOrderDraggedRenderer from "components/common/Scheduler/SchedulerRenderers/renderers/workOrderDraggedRenderer";
import WorkBlock from "domain/WorkBlock";
import useApplicationContext from "hooks/apollo/applicationContext/useApplicationContext";
import useScheduleBlock from "hooks/apollo/blocks/useScheduleBlock";
import useTrackUsage from "hooks/apollo/usageData/useTrackUsage";
import useBryntumScheduler from "hooks/useBryntumScheduler";
import DateTime from "utils/DateTime";
import DragFromSidebar from "./helpers/DragFromSidebar";

let dragHelperInstance = null;
export default function DragFromSidebarInitializer() {
  const applicationContext = useApplicationContext();
  const scheduleBlock = useScheduleBlock();
  const trackUsage = useTrackUsage();
  const { getBryntumScheduler } = useBryntumScheduler();

  if (!getBryntumScheduler()) return null;
  if (dragHelperInstance) return null;

  const handleDrop = ({ startDate, endDate, workOrder, line }) => {
    const newWorkBlock = WorkBlock.buildWithBlockTime({
      endsAt: DateTime.toISO8601(endDate),
      line,
      lockedOnSchedule: false,
      startsAt: DateTime.toISO8601(startDate),
      workOrder,
    });

    scheduleBlock(newWorkBlock);
  };

  dragHelperInstance = new DragFromSidebar({
    applicationContext,
    constrain: false,
    draggedNodeRenderer: workOrderDraggedRenderer,
    onDrop: handleDrop,
    onTrackUsage: trackUsage,
    schedule: getBryntumScheduler(),
  });

  return null;
}
